var TimeOfDay = /** @class */ (function () {
    function TimeOfDay() {
        this.MORNING = 'morning';
        this.AFTERNOON = 'afternoon';
        this.EVENING = 'evening';
    }
    return TimeOfDay;
}());
export { TimeOfDay };
var TimeOfDayBounds = /** @class */ (function () {
    function TimeOfDayBounds() {
        this.MORNING = 12;
        this.AFTERNOON = 17;
        this.EVENING = 23;
    }
    return TimeOfDayBounds;
}());
export { TimeOfDayBounds };
var DateDefaultsConst = /** @class */ (function () {
    function DateDefaultsConst() {
        this.DATE_FORMAT = 'YYYY-MM-DD';
        this.TIME_FORMAT = 'HH:mm:ss.SSS';
        this.DATE_TIME_FORMAT = 'YYYY-MM-DDTHH:mm:ss.SSS';
        this.FULL_DATE = 'YYYY-MM-DD[T]HH:mm';
    }
    return DateDefaultsConst;
}());
export { DateDefaultsConst };
//# sourceMappingURL=date-time.js.map